/* Sherrys WhatsApp: compact fixed glass widget; variant details resolved at click. No drag. */
(() => {
  const widget = document.querySelector('[data-sw-wa]');
  if (!widget) return;

  const productData = document.getElementById('sw-wa-product-data');
  let product = null;
  try { if (productData) product = JSON.parse(productData.textContent); }
  catch (_) { /* Generic WhatsApp fallback. */ }

  const phone = '923269617170';
  const closedKey = 'sherrys-whatsapp-help-closed-v3';
  const close = widget.querySelector('.sw-wa__dismiss');
  try { if (sessionStorage.getItem(closedKey) === '1') widget.classList.add('sw-wa--collapsed'); }
  catch (_) { /* Private browsing or storage blocked. */ }

  close?.addEventListener('click', () => {
    widget.classList.add('sw-wa--collapsed');
    try { sessionStorage.setItem(closedKey, '1'); } catch (_) { /* Storage blocked. */ }
  });

  function money(cents) {
    if (typeof cents !== 'number') return '';
    const currency = widget.dataset.currency || 'PKR';
    try {
      return new Intl.NumberFormat('en-PK', {style:'currency', currency, maximumFractionDigits:2}).format(cents / 100);
    } catch (_) {
      return `${currency} ${(cents / 100).toFixed(2)}`;
    }
  }

  function currentVariant() {
    if (!product || !Array.isArray(product.variants)) return null;
    const variantFromURL = new URL(window.location.href).searchParams.get('variant');
    // Prioritize active product add-to-cart form, rather than hidden modal forms.
    const candidates = [...document.querySelectorAll(
      'product-form form input[name="id"], form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]'
    )];
    const visible = candidates.find(el => {
      const form = el.closest('form');
      return form && form.getClientRects().length && !el.closest('dialog,[inert]');
    });
    const formVariantId = (visible || candidates[0])?.value;
    // Selected form id generally updates when size/color changes; URL used as fallback.
    const selectedId = formVariantId || variantFromURL;
    return product.variants.find(v => String(v.id) === String(selectedId)) ||
      product.variants.find(v => String(v.id) === String(variantFromURL)) ||
      product.variants.find(v => String(v.id) === String(product.selected_or_first_available_variant?.id)) ||
      product.variants[0];
  }

  function buildMessage() {
    if (!product) return `Hi! I need assistance.\nPage: ${window.location.href}`;
    const variant = currentVariant();
    const lines = ["Hi! I'm interested in this product:", '', `Product: ${product.title}`];
    if (variant) {
      const optionNames = Array.isArray(product.options) ? product.options : [];
      (variant.options || []).forEach((value, index) => {
        if (value && value !== 'Default Title') {
          lines.push(`${optionNames[index] || `Option ${index + 1}`}: ${value}`);
        }
      });
      const price = money(variant.price);
      if (price) lines.push(`Price: ${price}`);
      if (variant.sku) lines.push(`SKU: ${variant.sku}`);
      if (!variant.available) lines.push('Availability: Currently unavailable');
    }
    const url = new URL(window.location.pathname, window.location.origin);
    if (variant?.id) url.searchParams.set('variant', String(variant.id));
    lines.push(`Product link: ${url.toString()}`);
    const image = variant?.featured_image?.src || product.featured_image;
    if (image) {
      try { lines.push(`Image: ${new URL(image, window.location.origin).toString()}`); }
      catch (_) { /* Image URL is optional. */ }
    }
    lines.push('', 'Please share more details.');
    return lines.join('\n');
  }

  widget.querySelectorAll('a[data-sw-wa-link]').forEach(link => {
    link.addEventListener('click', () => {
      link.href = `https://wa.me/${phone}?text=${encodeURIComponent(buildMessage())}`;
      // Native target=_blank behavior remains (including keyboard interaction).
    });
  });
})();
